<template>
  <div>
    <v-layout
      ref="updateArea"
      :class="{ droping: droping, block: block }"
      column
      align-center
      class="upload-wrap pa-2 ma-0 mb-2 grey lighten-4"
    >
      <v-icon>cloud_upload</v-icon>
      <div>
        <input
          ref="pasteInput"
          title="點擊此區域，貼上圖片"
          class="pasteInput"
          readonly
          @focus="foucsing = true"
          @blur="foucsing = false"
        >
        <div v-if="droping">
          鬆開即可上傳
        </div>
        <div v-else>
          <div v-if="foucsing">
            現在可以貼上（Ctrl + V）
          </div>
          <div v-else>
            截圖貼上到此處／將圖片拖移至此處
          </div>
        </div>
      </div>
      <div>
        <span class="grey--text">或者</span>
        <v-btn
          :loading="uploading"
          :disabled="uploading"
          color="blue-grey"
          class="white--text ml-0"
          small
          @click="$refs.inputFileImage.click ()"
        >
          上傳圖片
        </v-btn>
      </div>
      <input
        ref="inputFileImage"
        type="file"
        style="display: none"
        accept="image/*"
        multiple
        @change="onFilePicked"
      >
    </v-layout>

    <v-layout
      row
      wrap
      class="ma-0 mt-4"
    >
      <div
        v-for="item in uploadList"
        :key="item.url"
        :style="{ width: imageWidth + 'px' }"
        class="imageItem mr-1 mb-1"
      >
        <v-card
          flat
          tile
        >
          <v-img
            :src="item.url | upyun('!/fh/150')"
            aspect-ratio="1"
            class="grey lighten-2"
          />
          <v-layout
            class="btns"
            row
            wrap
            justify-center
          >
            <!-- <v-icon @click="viewImage(item)">visibility</v-icon> -->
            <v-btn
              small
              class="info my-2"

              @click="deleteItem(item)"
            >
              <v-icon small>
                delete
              </v-icon>刪除
            </v-btn>
          </v-layout>
        </v-card>
      </div>
    </v-layout>

    <v-dialog
      v-model="showBigImage"
      width="1000"
    >
      <v-img
        v-if="bigImageSrc"
        :src="bigImageSrc.url | upyun()"
        class="grey lighten-2"
      />
    </v-dialog>
  </div>
</template>

<script>
import Compressor from 'compressorjs'

export default {
  props: {
    value: {
      require: true,
      type: Array
    },
    block: Boolean,
    max: {
      type: Number,
      default: 0 // 0 为不限制
    },
    imageWidth: {
      type: Number,
      default: 100
    },
    dir: {
      type: String,
      default: 'common'
    },
    listenGlobalPaste: Boolean, // 不处理全局粘贴事件
    disabled: Boolean
  },
  data () {
    return {
      uploadList: this.value,
      uploadHistory: [],
      uploading: false,
      droping: false,
      foucsing: false,
      showBigImage: false,
      bigImageSrc: ''
    }
  },
  watch: {
    value: {
      handler () {
        this.uploadList = this.value
      },
      immediate: true
    },
    uploadList () {
      this.$emit('input', this.uploadList)
    }
  },
  mounted () {
    document.addEventListener('paste', this.onPaste)
    this.$refs.updateArea.addEventListener('dragover', this.onDragover)
    this.$refs.updateArea.addEventListener('dragleave', this.onDragleave)
    this.$refs.updateArea.addEventListener('drop', this.onDrop)
  },
  beforeDestroy () {
    document.removeEventListener('paste', this.onPaste)
    this.$refs.updateArea.removeEventListener('dragover', this.onDragover)
    this.$refs.updateArea.removeEventListener('dragleave', this.onDragleave)
    this.$refs.updateArea.removeEventListener('drop', this.onDrop)
  },
  methods: {
    deleteItem (item) {
      if (this.uploadHistory.indexOf(item) > -1) {
        this.$store.dispatch('upyun/delete', {
          path: item.url
        })
      }
      this.uploadList.splice(this.uploadList.indexOf(item), 1)
    },
    onFilePicked (e) {
      if (e.target.files.length) {
        this.uploadFile([...e.target.files])
      }
    },
    viewImage (item) {
      this.showBigImage = true
      this.bigImageSrc = item
    },
    async uploadFile (files) {
      if (this.uploading) {
        return
      }
      this.uploading = true
      if (this.max > 0) {
        files = files.slice(0, this.max - this.uploadList.length)
      }
      try {
        await Promise.all(files.map(file => {
          return new Promise((resolve, reject) => {
            // eslint-disable-next-line
            new Compressor(file, {
              quality: 0.8,
              maxWidth: 1500,
              maxHeight: 1500,
              minWidth: 100,
              minHeight: 100,
              success: (result) => {
                console.log(result)
                return this.$store.dispatch('upyun/uploadImg', {
                  file: result,
                  policyParams: {
                    dir: this.dir
                  }
                }).then(({ data }) => {
                  this.uploadList.push(data)
                  this.uploadHistory.push(data)
                  resolve()
                }).catch(e => {
                  console.error(e)
                  this.$snackbar(e.toString())
                  reject(new Error(e))
                })
              },
              error (err) {
                this.$snackbar(err.message)
                reject(new Error(err.message))
              },
            })
          })
        }))
      } finally {
        this.uploading = false
        this.$refs.inputFileImage.value = null
      }
    },
    onPaste (e) {
      if (!this.foucsing && !this.listenGlobalPaste) {
        return
      }
      const file = [...e.clipboardData.items].find(item => item.type.indexOf('image') !== -1)
      if (!file) return

      this.uploadFile([file.getAsFile()])
    },
    onDragover (e) {
      e.preventDefault()
      this.droping = true
    },
    onDragleave (e) {
      e.preventDefault()
      this.droping = false
    },
    onDrop (e) {
      e.preventDefault()
      this.droping = false
      if (e.dataTransfer.files.length) {
        this.uploadFile([...e.dataTransfer.files])
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.imageItem {
}

.upload-wrap {
  text-align: center;
  border: 2px dashed transparent !important;
  position: relative;
  &.block{
    width: 100%;
  }
  &:focus {
    border: 2px dashed #f00 !important;
  }
  &.droping {
    border: 2px dashed #afacac !important;
  }

  .pasteInput {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    &:focus {
      outline-style: auto;
      outline-color: rgb(59, 153, 252);
    }
  }
}
</style>
